import React from 'react';
import moment from 'moment';
import Toggle from 'react-toggle';
import { Link } from 'react-router-dom'
import _ from 'lodash'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUpRightFromSquare } from '@fortawesome/free-solid-svg-icons';

import ClipboardCopy from '../../widgets/clipboard_copy';
import UpdateEmailModal from './../update_email';
import AddBonusModel from '../add_bonus';
import ResetBonusModel from '../reset_bonus';
import UpdateMemberStatus from '../update_member_status';
import UpdateTimezoneModal from '../update_timezone';
import * as Helpers from '../../../helpers/helper'
import * as IndividualUserConstants from '../helpers/constant'
import ClickToCopy from '../../widgets/copy_onclick';
import * as Constants from '../../../helpers/constants'
import CustomOverlayTrigger from '../../widgets/overlay_trigger'

import './../../../static/css/profile.css'


export const emailFormatter = ({ client, value, userData, user_id, getUserInfo }) => {
  return (
    <div className="d-flex flex-wrap">
      <div className='d-flex'>
        <CustomOverlayTrigger
          content={value}
          placement='top'
        >
          <span className="me-2">{Helpers.truncateEmail(value, 20)}</span>
        </CustomOverlayTrigger>
        <span className="d-flex align-items-center">
          <ClipboardCopy textToCopy={value} />
        </span>
        <div className="px-2">
          {_.includes(IndividualUserConstants.BASIC_INFO[client].SHOW_BUTTONS, 'edit_email') ? (
            <UpdateEmailModal
              client={client}
              couserid={user_id}
              getUserInfo={getUserInfo}
              data={userData}
            />
          ) : null}
        </div>
      </div>
    </div>
  )
}
export const phoneFormatter = ({ value }) => {
  return (
    <div className='d-flex'>
      {value ? (
        <ClickToCopy text={value} />
      ) : '-'}
    </div>
  )
}

export const UserRole = ({ value }) => {
  return (
    <p>{value === 'analyst' ? 'Executive' : Helpers.capitalizeFirstLetter(value)}</p>
  )
}

export const remainingCreditsFormatter = ({ client, userData, getUserInfo }) => {
  return (
    <div className="d-flex gap-2 remaining-credits">
      {userData.user_type === 'individual' ? (
        <AddBonusModel
          client={client}
          getUserInfo={getUserInfo}
          name={userData.name}
          email={userData.email}
          userData={userData}
        />
      ) : null}
      {userData.user_type === 'individual' ? (
        <ResetBonusModel
          client={client}
          getUserInfo={getUserInfo}
          name={userData.name}
          userData={userData}
        />
      ) : null}
    </div>
  )
}

export const jobTitleFormatter = ({ additionalData }) => {
  return (
    <>
      {additionalData && additionalData.job_title
        ? Helpers.capitalizeFirstLetter(additionalData.job_title)
        : '-'}
    </>
  )
}

export const industryFormatter = ({ additionalData }) => {
  return (
    <>
      {additionalData && additionalData.industry
        ? Helpers.capitalizeFirstLetter(additionalData.industry)
        : '-'}
    </>
  )
}

export const signupFormatter = ({ additionalData }) => {
  return (
    <>
      {additionalData?.user_profile_additional_info && additionalData.user_profile_additional_info.signup_source && additionalData.user_profile_additional_info.signup_method
        ? `${Helpers.capitalizeFirstLetter(additionalData.user_profile_additional_info.signup_source)} / ${Helpers.capitalizeFirstLetter(additionalData.user_profile_additional_info.signup_method)}`
        : 'Direct / Email'}
    </>
  )
}

export const companyNameFormatter = ({ additionalData }) => {
  return (
    <>s
      {additionalData && additionalData.organization_name
        ? Helpers.capitalizeFirstLetter(additionalData.organization_name)
        : '-'}
    </>
  )
}

export const userIdFormatter = ({ value }) => {
  return (
    <div className='text-break'>
      {value ? (
        <ClickToCopy text={value} />
      ) : '-'}
    </div>
  )
}

export const orgIdFormatter = ({ value, userData, client }) => {
  return (
    <div className='d-flex'>
      <div>
        {value ? (
          <ClickToCopy text={value} />
        ) : '-'}
      </div>
      <div className='px-1'>
        {userData.user_type === 'organization' ? (
          <>
            <Link
              to={`/${client}/organization_info?org_id=${userData.org_id}`}
              title="org info"
              className='ms-1'
            >
              <FontAwesomeIcon
                icon={faArrowUpRightFromSquare}
                className='text-primary'
              />
            </Link>
          </>
        ) : null}
      </div>
    </div>
  )
}

export const activatedOnFormatter = ({ value }) => {
  return (
    <>
      {value ? (
        <ClickToCopy text={moment(value).format('DD-MMM-YYYY @ h:mm:ss A')} />
      ) : 'Yet to Activate'}
    </>
  )
}

export const memberStatusFormatter = ({ client, value, userData, user_id, getUserInfo }) => {
  return (
    <>
      <div className={userData.account_status === 'live' ? 'text-success' : 'text-danger'}>
        {Helpers.capitalizeFirstLetter(value) ?? '-'}
      </div>
      {userData.user_type == 'organization' && userData.user_role !== 'owner' ? (
        <UpdateMemberStatus
          couserid={user_id}
          getUserInfo={getUserInfo}
          userData={userData}
          client={client}
        />
      ) : null}
    </>
  )
}

export const accountStatusFormatter = ({ value, userData }) => {
  return (
    <div className={userData.status === 'active' ? 'text-success' : 'text-danger'}>
      {Helpers.capitalizeFirstLetter(value) ?? '-'}
    </div>
  )
}

export const radarFormatter = ({ userData, isChecked, handleToggleChange }) => {
  return (
    <>
      {userData && userData.user_role === 'owner' ? (
        <Toggle
          checked={isChecked}
          onChange={handleToggleChange}
          disabled={
            userData.status === 'active' &&
              userData.account_status === 'live' &&
              userData.activated_on
              ? false
              : true
          }
        />
      ) : (
        '-'
      )}
    </>
  )
}

export const timezoneFormatter = ({ value, userData, user_id, getUserInfo, client }) => {
  return (
    <div className='d-flex'>
      <div>
        {value ?? '-'}
      </div>
      <div>
        {userData.user_type === 'individual' ? (
          <div className='mx-2'>
            <UpdateTimezoneModal
              couserid={user_id}
              getUserInfo={getUserInfo}
              data={userData}
              client={client}
            />
          </div>
        ) : null}
      </div>
    </div>
  )
}

export const totalAmountPaidFormatter = ({ additionalData }) => {
  if (additionalData && !_.isEmpty(additionalData.payment_info))
    return Number(additionalData.payment_info.total).toLocaleString()
  else
    return '-'
}
export const lastPurchasedOnFormatter = ({ additionalData }) => {
  if (additionalData && !_.isEmpty(additionalData.payment_info)) {
    const timestamp = additionalData.payment_info.last_purchased_on;
    const formattedDate = moment(timestamp).format('DD-MMM-YYYY @ h:mm:ss a');
    const humanReadable = moment(timestamp).fromNow();
    const capitalizedHumanReadable = _.capitalize(humanReadable);

    return (
      <span>
        <CustomOverlayTrigger
          placement='top'
          content={formattedDate}
        >
          <span>{capitalizedHumanReadable}</span>
        </CustomOverlayTrigger>
      </span>
    );
  } else {
    return '-';
  }
};




export const totalPaymentCountFormatter = ({ additionalData }) => {
  if (additionalData && !_.isEmpty(additionalData.payment_info))
    return Number(additionalData.payment_info.count)
  else
    return '-'
}

export const nextCreditsAllocationDate = ({ additionalData }) => {
  let creditAllocationDate = '-';

  if (_.isEmpty(additionalData?.subscription_details)) {
    return creditAllocationDate;
  }

  let planSubs = _.find(additionalData.subscription_details, { product_type: 'plan' });

  if (!planSubs || !planSubs.credits_renewal_date) {
    return creditAllocationDate;
  }

  let planRenewal = { count: planSubs.product_renewal?.count, unit: planSubs.product_renewal?.unit };
  let creditRenewal = { count: planSubs.credits_renewal?.count, unit: planSubs.credits_renewal?.unit };

  if (planSubs.status !== 'active' && _.isEqual(planRenewal, creditRenewal)) {
    return creditAllocationDate;
  }

  if (!planSubs.credits_renewal_date)
    return creditAllocationDate

  creditAllocationDate = moment(planSubs.credits_renewal_date).format('Do MMMM YYYY, h:mm:ss A')
  const humanReadable = moment(planSubs.credits_renewal_date).fromNow()


  let subscriptionColor = planSubs.status !== 'active' ? 'text-danger' : 'text-success';

  return (
    <span>
      <CustomOverlayTrigger
        placement="top"
        content={<span>{creditAllocationDate}</span>}
      >
        <span className={subscriptionColor}>{_.capitalize(humanReadable)}</span>
      </CustomOverlayTrigger>
    </span>
  );
}

export const planFormatter = ({ additionalData, userData }) => {

  let productName = '-'
  if (userData.user_role !== Constants.DISPLAY_USER_ROLES.owner.value)
    return productName

  const subscriptionDetails = additionalData.subscription_details
  const planSubs = _.find(subscriptionDetails, { product_type: 'plan' })

  if (planSubs && !_.isEmpty(planSubs.product_name)) {
    productName = planSubs.product_name


    let subscriptionColor = planSubs.status !== 'active' ? 'text-danger' : 'text-success';

    return (
      <div className={`truncate-text ${subscriptionColor}`}>
        <CustomOverlayTrigger
          placement='top'
          content={<span>{productName}</span>}
        >
          <span>{productName}</span>
        </CustomOverlayTrigger>
      </div>
    );
  }

  return '-';
};

export const nextBillingDate = ({ additionalData }) => {
  let formattedDate = '-';

  if (_.isEmpty(additionalData.subscription_details))
    return formattedDate

  const plan = _.find(additionalData.subscription_details, { product_type: 'plan' })

  if (plan.status !== 'active' || !plan.end_time) {
    return formattedDate;
  }

  formattedDate = moment(plan.end_time).format('Do MMMM YYYY, h:mm:ss A')
  const humanReadable = moment(plan.end_time).fromNow()


  let subscriptionColor = plan.status !== 'active' ? 'text-danger' : 'text-success';

  return (
    <span>
      <CustomOverlayTrigger
        placement='top'
        content={<span>{formattedDate}</span>}
      >
        <span className={subscriptionColor}>{_.capitalize(humanReadable)}</span>
      </CustomOverlayTrigger>
    </span>
  );
}


export const totalRemainingCreditsFormatter = ({ value }) => {
  return (
    <>
      {
        value == null
          ? 'Unlimited'
          : value.toLocaleString()
      }
    </>
  )
}


export const lowCreditThreshold = ({ userData }) => {
  let data = '-'
  let thresholdSign = ''
  if (userData.settings?.low_credit_balance) {
    data = userData.settings.low_credit_balance.min_threshold ?? '-'
    if (data !== '-' && userData.credits?.total != null && data >= userData.credits.total) {
      thresholdSign = 'text-danger'
    }
  }
  return (
    userData.user_type === 'organization' && userData.user_role === 'owner' || userData.user_type === 'individual'
      ? <span className={thresholdSign}>{data !== '-' ? data.toLocaleString() : '-'}</span>
      : '-'
  )
}

export const billableFormatter = (userData) => {
  const subscription = userData.userData.subscription
  const planSubs = _.find(subscription, { product_type: 'plan' })


  if (!planSubs.price.total_price || !planSubs.product_renewal.unit) {
    return '-';
  }

  const duration = Helpers.getRenewalUnit(planSubs.product_renewal)
  const currency = planSubs.price.currency
  const amount = planSubs.price.total_price.toLocaleString(Constants.CURRENCY[currency.toUpperCase()].LOCALE);
  const currencySymbol = Constants.CURRENCY[currency].symbol
  const status = (planSubs.status || null)

  if (!status) {
    return '-';
  }

  const billable = `${currencySymbol}${amount}/${duration}`;
  const subscriptionColor = status !== 'active' ? 'text-danger' : 'text-success';

  return (
    <span className={subscriptionColor}>
      {billable}
    </span>
  )
}

// cop formatterrs
export const copTotalAmountPaidFormatter = ({ value }) => {
  return (
    <>
      {value ? Number(value).toLocaleString() : '-'}
    </>
  )
}

export const copLastPurchasedOnFormatter = ({ value }) => {
  if (value) {
    const formattedDate = moment(value).format('DD-MMM-YYYY @ h:mm:ss a');
    const humanReadable = moment(value).fromNow();
    const capitalizedHumanReadable = _.capitalize(humanReadable);

    return (
      <span>
        <CustomOverlayTrigger
          placement='top'
          content={<span>{formattedDate}</span>}
        >
          <span>{capitalizedHumanReadable}</span>
        </CustomOverlayTrigger>
      </span>
    );
  }

  return '-';
};



export const copTotalPaymentCountFormatter = ({ value }) => {
  return (
    <>
      {value ? value : '-'}
    </>
  )
}
